import { render, staticRenderFns } from "./layout-nav-item.vue?vue&type=template&id=116669b4&scoped=true&"
import script from "./layout-nav-item.vue?vue&type=script&lang=js&"
export * from "./layout-nav-item.vue?vue&type=script&lang=js&"
import style0 from "./layout-nav-item.vue?vue&type=style&index=0&id=116669b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "116669b4",
  null
  
)

export default component.exports